import { AccessRequestDTO } from '@/services/dtos/accessRequest.dto';

export const validateAccessRequest = (
  accessRequest: AccessRequestDTO | null | undefined
): boolean => {
  if (!accessRequest) return false;

  const { cpf, name, store, status } = accessRequest;

  const isFieldValid = (field: string | undefined | null) =>
    field != null && field.trim().length > 0;

  const storeCanBeNumber = !isNaN(Number(store));

  return (
    isFieldValid(cpf) &&
    isFieldValid(name) &&
    isFieldValid(store) &&
    isFieldValid(status) &&
    storeCanBeNumber
  );
};
